
















































































import { Component, Emit, Vue } from "vue-property-decorator";
import { PriceOptimizerState } from "@/models";
import { State } from "vuex-class";
import { formatDate } from "@/helpers/functions/format-date";

@Component({
  name: "FilterChips"
})
export default class FilterChips extends Vue {
  // ===== Data ===== //
  public maxUnitTypeNames = 2;
  // ===== Store ===== //
  @State("priceOptimizer") private priceOptimizer!: PriceOptimizerState;
  // ===== Methods ===== //
  /* istanbul ignore next */
  @Emit("cancelFilter")
  public cancelFilter(id: number) {
    return id;
  }
  /* istanbul ignore next */
  public formatDate = formatDate;

  public formatStdRate(value: string) {
    switch (value) {
      case "market_rate_min":
        return "Market Rate Low";
      case "market_rate_max":
        return "Market Rate High";
      case "market_rate_avg":
        return "Market Rate Average";
      case "ipr_min":
        return "IPR Low";
      case "ipr_max":
        return "IPR High";
      case "ipr_avg":
      default:
        return "IPR Average";
    }
  }
}
